module.exports = __webpack_public_path__ + "static/legalBannerIcon-c34b72a60e6282c9abed384a3d13eb62.png";